import { NgFor, NgIf } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { WebcamImage, WebcamInitError, WebcamModule  } from 'ngx-webcam';
import { Observable, Subject } from 'rxjs';

@Component({
  selector: 'jabil-camera',
  standalone: true,
  imports: [NgIf, NgFor, WebcamModule],
  templateUrl: './camera.component.html',
  styleUrl: './camera.component.scss'
})
export class CameraComponent {
  private trigger: Subject<void> = new Subject<void>();
  photos: string[] = [];

  @Input() maxPhotos:number|null = null;
  @Output() photoTaken = new EventEmitter<string[]>();
  @Output() closed = new EventEmitter<void>();
  @Output() initError =  new EventEmitter<WebcamInitError>();

  get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  takePhoto(): void {
    this.trigger.next();
  }

  handleImage(webcamImage: WebcamImage): void {    
    this.photos.push(webcamImage.imageAsDataUrl);
  }

  close(): void {
    this.closed.emit();
  }
  
  removePhoto(index: number) {
    this.photos.splice(index, 1);
  }


  done(){
    this.photoTaken.emit(this.photos);
    this.close();
  }
}
